import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicComponent } from '@app/public/public.component';
import { PublicGuard } from '@shared/guards/public.guard';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'forget',
        loadChildren: () =>
          import('@app/public/forget/forget.module').then((m) => m.ForgetModule)
      },
      {
        path: 'login',
        canActivate: [PublicGuard],
        loadChildren: () =>
          import('@app/public/login/login.module').then((m) => m.LoginModule)
      },
      {
        path: 'password',
        loadChildren: () =>
          import('@app/public/password/password.module').then(
            (m) => m.PasswordModule
          )
      },
      {
        path: 'reset/:id',
        loadChildren: () =>
          import('@app/public/reset/reset.module').then((m) => m.ResetModule)
      },
      {
        path: 'verify/:id',
        loadChildren: () =>
          import('@app/public/verify/verify.module').then((m) => m.VerifyModule)
      },
      {
        path: ':id',
        loadChildren: () =>
          import('@app/public/profiles/profiles.module').then(
            (m) => m.ProfilesModule
          )
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
